(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('SellerCampaignFactory', SellerCampaignFactory);

    SellerCampaignFactory.$inject = ['$resource'];

    function SellerCampaignFactory ($resource) {
        var resourceUrl =  'admin/api/campaign';

        return $resource(resourceUrl, {}, {
            'findBySellerId': {
                url: resourceUrl + '/seller-campaigns',
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'findProgressBySellerId': {
                url: resourceUrl + '/seller-campaigns/progress',
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
